import { lazy } from "react"
import { Outlet } from "react-router-dom"
import { MissingPage } from "~/shared/pages/system"
import { useEngagementContext } from "@oysterhr/identity/EngagementContext"
import { OysterRouter } from "~/router/type"
import { LazyLoadingSuspenseWithErrorBoundary } from "@oysterhr/feature-components"
import { ContractBilling } from "@oysterhr/schema"

const ContractorInvoicesPage = lazy(
  () => import("./pages/ContractorInvoicesPage/ContractorInvoicesPage"),
)
const ContractorInvoiceEditPage = lazy(
  () => import("./pages/ContractorInvoicePage/ContractorInvoiceEditPage"),
)
const ContractorInvoicePage = lazy(
  () => import("./pages/ContractorInvoicePage/ContractorInvoicePage"),
)

const ContractorInvoicesProtectedRoute = () => {
  const { engagement, isEngaged } = useEngagementContext()
  const contract = engagement?.contract
  const canSeeInvoices = isEngaged && contract?.billingType !== ContractBilling.Fixed

  return canSeeInvoices ? <Outlet /> : <MissingPage />
}

export const contractorInvoicingRoutes: OysterRouter = {
  DeprecatedLeftSidebar: [
    {
      path: "invoices",
      children: [
        {
          path: "",
          element: (
            <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
              <ContractorInvoicesPage />
            </LazyLoadingSuspenseWithErrorBoundary>
          ),
        },
        {
          element: <ContractorInvoicesProtectedRoute />,
          children: [
            {
              path: "new",
              element: (
                <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
                  <ContractorInvoicePage />
                </LazyLoadingSuspenseWithErrorBoundary>
              ),
            },
            {
              path: ":contractorInvoiceStrongId/edit",
              element: (
                <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
                  <ContractorInvoiceEditPage />
                </LazyLoadingSuspenseWithErrorBoundary>
              ),
            },
          ],
        },
      ],
    },
  ],
  DeprecatedFullScreen: [],
}
